/* eslint-disable max-len */
import { buildBaseEventData, buildSubContentAnalyticsEvent, buildItemAnalyticsEvent, buildCartAnalyticsEvent, buildStashAnalyticsEvent, buildErrorAnalyticsEvent } from './commonAnalytics';
import { Utils } from './sendAnalyticsEvent';

export const trackOverlayInteraction = (primaryCategory, eventName) => {
  const clickEvent = buildBaseEventData(primaryCategory, eventName);
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackSubObjectInteractions = (primaryCategory, eventName, subContent) => {
  const clickEvent = buildSubContentAnalyticsEvent(primaryCategory, eventName, subContent);
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackItemInteractions = (primaryCategory, eventName, items) => {
  const clickEvent = buildItemAnalyticsEvent(primaryCategory, eventName, items);
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackCartInteractions = (cartID, primaryCategory, eventName, items) => {
  const clickEvent = buildCartAnalyticsEvent(cartID, primaryCategory, eventName, items);
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackStashInteractions = (primaryCategory, eventName) => {
  const clickEvent = buildStashAnalyticsEvent(primaryCategory, eventName);
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackErrorInteractions = (errorObject, primaryCategory, eventName) => {
  const clickEvent = buildErrorAnalyticsEvent(errorObject, primaryCategory, eventName);
  Utils.sendAnalyticsEvent(clickEvent);
};
